<template>
  <div style="height: 90%; position: relative; margin-top: 10px;">
    <div style="font-size: 18px; color: white; font-family: 黑体; font-weight: bold; ">各区维修/报修表</div>
    <div id="leftTwo" style="height: 100%; display: flex; flex-wrap: nowrap;padding-right: 20px; margin-top: 10px; width: 100%; position: relative">
<!--      <div id="YLabel" style="width: 70px; height: calc(81% + 1px - 16px); display: flex; flex-direction: column; justify-content: space-around; border-right: 1px solid #8fb4d7;overflow-y: scroll">-->
<!--        <div v-for="item in areas" class="leftTwoYLabelItem" style="background-color: rgba(0,0,0,0); color: white;font-family: 黑体; font-size: 12px; flex-grow: 0;-->
<!--          text-align:center; ">{{item}}</div>-->
<!--      </div>-->
      <div id="NotYLabelRightTwo" style="width: calc(100% - 40px); height: 90%;position: relative; overflow-x: scroll;  overflow-y: hidden;">
        <div id="overflowContent" style="width: 200%; position: relative; height: 100%;">
          <div id="backPanel" style="width: 100%; height: 90%; position: absolute; display: flex; flex-direction: row; flex-wrap: nowrap;" >
            <!-- 画竖直线 -->
            <div v-for="i in 13" style="width: 10%; height: 100%; border-right: 1px solid rgba(255,255,255, 0.1)"></div>
          </div>
          <div id="leftTwoContent" style="width: 100%; background-color: rgba(0,0,0,0); height: 90%;  justify-content: space-around; border-left: 1px; border-bottom: 1px; border-color: white;margin-left: 1px;overflow-y:scroll">
            <div v-for="item in datas" class="leftTwoRow" style="background-color: #1f53c1; color: white; flex: 1; margin: 8px 0; display: flex; flex-direction: row; flex-wrap: nowrap; font-size: 8px; justify-content: space-around;height: 10%">
              <div v-for="item2 in item" class="leftTwoCon tentItem"  style="font-size:12px; font-family: 黑体; -webkit-transform:scale(1); width: 100%; text-align: center; ">{{item2}}</div>
            </div>
          </div>
          <div id="XLabel" style="width: 100%; display: flex; justify-content: space-around; color: white; border-top: 1px solid #8fb4d7">
            <div v-for="item in months" style="font-size:12px;-webkit-transform:scale(1); font-family: 黑体; text-align: center;float: right" >{{item}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HomeRightTwo',
  props: ['areaId'],
  data(){
    return {
      months: ['月份','1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      areas: [],
      interval: null, // 轮询
      datas:[],
      // 各区维修/报修表
      AreaBreakSta:{
        "version": 1,
        "method": "synthScreen.AreaBreakSta",
        "params": {
          "areaId":"0",
        },
        "token": "#",
        "id": 0
      },
      midDate:[],

    }
  },
  methods:{
    getAreaBreakSta(){
      this.AreaBreakSta.token = this.$store.state.token;
      console.log('获取各区维修/报修表');
      console.log(this.AreaBreakSta);
      this.$axios.post(this.$newMainUrl, this.AreaBreakSta).then(res=> {
        // this.$message({
        //   type:'success',
        //   message:'成功'
        // })
        this.datas.length = 0; // datas归零
        if(res.data.hasOwnProperty('result')){
          let reportSta = res.data.result.reportStatus;
          let repairSta = res.data.result.repairStatus;
          let cityNumber = Object.keys(reportSta).sort();
          let areas = [];
          for(let i = 0;i<cityNumber.length;i++) {
            let area= new Object();
              area.value = i;
              area.name = cityNumber[i];
              areas.push(area)
          }
          this.areas = areas
          let keys = Object.keys(reportSta).sort();
          //let keys = ["01","02","03","04","05","06","07","08","09","10"]
            let t = [];

            for(let i = 0;i<keys.length;i++){
              let tt = [];
              tt.push(areas[i].name)
              for(let j=0;j<reportSta[keys[i]].length;j++){
                tt.push(reportSta[keys[i]][j]+"/"+repairSta[keys[i]][j]);
              }
              t.push(tt);
            }
            this.datas = t;

        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    }

  },
  mounted () {
    //var NotYLabelRightTwo = document.getElementById('NotYLabelRightTwo');
    //NotYLabelRightTwo.scrollLeft = NotYLabelRightTwo.clientWidth;

    this.getAreaBreakSta();
    this.interval = setInterval(()=>{
      this.getAreaBreakSta();
    }, 3000);
  },
  destroyed () {
    clearInterval(this.interval);
    // this.$message({
    //   type:'error',
    //   message:'结束'
    // })
  }
}
</script>

<style scoped>

</style>
<style lang="scss">
  #NotYLabelRightTwo::-webkit-scrollbar
  {
    width: 50px;
    height: 16px;
    /*background-color: red;*/
  }
  #NotYLabelRightTwo::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #1f53c1;
  }
  #NotYLabelRightTwo::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: rgba(255,255,255,0.1);
  }
  /*#NotYLabelRightTwo::-webkit-scrollbar-thumb {!*滚动条里面小方块*!*/
  /*border-radius: 10px;*/
  /*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
  /*background: #535353;*/
  /*}*/
</style>
